import { render, staticRenderFns } from "./ShopFooter.vue?vue&type=template&id=de0df406&scoped=true"
import script from "./ShopFooter.vue?vue&type=script&lang=js"
export * from "./ShopFooter.vue?vue&type=script&lang=js"
import style0 from "./ShopFooter.vue?vue&type=style&index=0&id=de0df406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_18124a4e9c6dea8cfaa8db968b5e834e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de0df406",
  null
  
)

export default component.exports